module.exports = __webpack_public_path__ + "img/motorway_3x1.92dab3af.svg";